import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {UploaderComponent} from '../../uploader';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {NzModalService} from 'ng-zorro-antd';
import {Subject} from 'rxjs';
import {DistributorsService, RootService} from '../../../services';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {capitalizeFirstLetter, removeAllSpacingBetweenWords} from '../../../helpers';
import {DomSanitizer} from '@angular/platform-browser';
import {HandleVideo} from '../../common/handle-video';

@Component({
  selector: 'create-distributors',
  templateUrl: './create-distributors.component.html',
  styleUrls: ['./create-distributors.component.scss']
})
export class CreateDistributorsComponent extends HandleVideo implements OnInit, OnDestroy {

  unsubscribe$ = new Subject<void>();
  avatar: any[] = [];
  background: any[] = [];

  name = ''
  tax = ''
  address = ''
  isVisible = false;
  countries: any;
  country_code: any;
  introImage: any[] = [];
  introVideo: any[] = [];
  public config = {
    placeholder: '',
    tabsize: 2,
    height: '250px',
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      // ["insert", ["link", "video"]],
      ['insert', ['link']],
    ],
    fontNames: [
      'Helvetica',
      'Arial',
      'Arial Black',
      'Comic Sans MS',
      'Courier New',
      'Roboto',
      'Times',
    ],
    disableDragAndDrop: true

  };
  // tslint:disable-next-line:variable-name
  idItem;
  actions = [
    {label: 'Gán sản phẩm', value: 0},
    {label: 'Gỡ sản phẩm', value: 1},
    {label: 'Export', value: 2},
    {label: 'Export tất cả', value: 3},
  ];
  city = null;
  cityNew = [];
  listWard = [];
  districts = null;
  street = null;
  idDistributor;
  @Output() loadDataParent = new EventEmitter();
  isLoadingBtn = false;

  constructor(
    public fb: FormBuilder,
    public modalService: NzModalService,
    public distributorsService: DistributorsService,
    public rootService: RootService,
    public notification: NzNotificationService,
    public sanitizer: DomSanitizer,
    public modal: NzModalService,
  ) {
    super(modalService, fb, sanitizer, modal, notification, rootService);
  }

  ngOnInit() {
    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    this.loadData();
    this.rootService.listCountries().pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        if (res.code === 1) {
          this.countries = res.data.items;
        }
      }
    );

    this.rootService.getLocationNew({
      type: 1
    }).subscribe((res) => {
      this.cityNew = res.data.data;
      // console.log("this.city2", this.city)
    });

    this.form_step1.get('provinceNewId').valueChanges.pipe(debounceTime(500)).subscribe(val => {
      if (val) {
        this.rootService.getLocationNew({
          type: 2,
          parentId: val
        }).subscribe((res: any) => {
          if (res.code === 1) {
            this.listWard = res && res.data && res.data.data ?  res.data.data : [];
          }
        });
      }
    });
  }

  loadData() {
    this.rootService.listCities().pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      this.city = res.data.items;
    });

  }

  getDistrictsNew($event: any) {
    this.form_step1.get('wardNewId').setValue(null);
  }

  getDistricts($event: any) {
    this.districts = null;
    this.street = null;
    this.form_step1.get('district_id').setValue(null);
    this.form_step1.get('streetId').setValue(null);
    if ($event !== null) {
      this.rootService.listDistricts($event).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
        this.districts = res.data.items;
      });
    }

  }

  getStreet($event: any) {

    this.street = null;
    this.form_step1.get('streetId').setValue(null);
    if ($event !== null) {
      this.rootService.listWards($event).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
        this.street = res.data.items;
      });
    }
  }

  handleCancel(): void {
    this.isVisible = false;
    this.avatar = [];
    this.background = [];
    this.form_step1.reset();

  }

  citiChange(event) {
    if (event) {
      this.country_code = this.country_code = event.split('-')[1];
      if (this.country_code !== 'VN') {
        this.form_step1.controls.province_id.clearValidators();
        this.form_step1.controls.province_id.disable();
        this.form_step1.controls.district_id.clearValidators();
        this.form_step1.controls.district_id.disable();
        this.form_step1.controls.streetId.clearValidators();
        this.form_step1.controls.streetId.disable();
        this.form_step1.controls.provinceNewId.clearValidators();
        this.form_step1.controls.provinceNewId.disable();
        this.form_step1.controls.wardNewId.clearValidators();
        this.form_step1.controls.wardNewId.disable();

        this.form_step1.controls.province_id.setValue(null);
        this.form_step1.controls.district_id.setValue(null);
        this.form_step1.controls.streetId.setValue(null);
        this.form_step1.controls.provinceNewId.setValue(null);
        this.form_step1.controls.wardNewId.setValue(null);
        return;
      }
      this.form_step1.controls.province_id.setValidators(Validators.required);
      this.form_step1.controls.province_id.enable();
      this.form_step1.controls.district_id.setValidators(Validators.required);
      this.form_step1.controls.district_id.enable();
      this.form_step1.controls.streetId.setValidators(Validators.required);
      this.form_step1.controls.streetId.enable();
      this.form_step1.controls.provinceNewId.setValidators(Validators.required);
      this.form_step1.controls.provinceNewId.enable();
      this.form_step1.controls.wardNewId.setValidators(Validators.required);
      this.form_step1.controls.wardNewId.enable();
    } else {
      this.form_step1.controls.province_id.clearValidators();
      this.form_step1.controls.province_id.disable();
      this.form_step1.controls.district_id.clearValidators();
      this.form_step1.controls.district_id.disable();
      this.form_step1.controls.streetId.clearValidators();
      this.form_step1.controls.streetId.disable();
      this.form_step1.controls.provinceNewId.clearValidators();
      this.form_step1.controls.provinceNewId.disable();
      this.form_step1.controls.wardNewId.clearValidators();
      this.form_step1.controls.wardNewId.disable();

      this.form_step1.controls.province_id.setValue(null);
      this.form_step1.controls.district_id.setValue(null);
      this.form_step1.controls.streetId.setValue(null);
      this.form_step1.controls.provinceNewId.setValue(null);
      this.form_step1.controls.wardNewId.setValue(null);
    }
  }

  onSubmit() {


    let newForm = {...this.form_step1.value};
    if (this.form_step1.value.country_id.split('-')[1] !== 'VN') {
      newForm.province_id = 0;
      newForm.district_id = 0;
      newForm.streetId = 0;
    }
    newForm.name = capitalizeFirstLetter(removeAllSpacingBetweenWords(this.form_step1.value.name));
    newForm.country_id = undefined;
    if(newForm.intro) {
      newForm.intro  = newForm.intro.trim();
    }
    // tslint:disable-next-line:radix
    newForm.countryId = parseInt(this.form_step1.value.country_id.split('-')[0]);
    newForm.introVideo = this.introVideo;

    const arrImage: any[] = this.introImage.map(z => z.url);
    // @ts-ignore
    newForm = {...newForm, introImage: arrImage.flat()};
    if (newForm.addressNew) {
      newForm.province_id = null;
      newForm.district_id = null;
      newForm.address = null;
    } else {
      newForm.provinceNewId = null;
      newForm.wardNewId = null;
      newForm.addressNewName = null;
    }
    console.log(newForm)
    this.distributorsService.editDistributor(this.idDistributor, newForm).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      if (res.code === 1) {
        this.notification.create(
          'success',
          'Thành công',
          'Cập nhật nhà phân phối thành công'
        );
        this.form_step1.reset();
        this.avatar = [];
        this.background = [];
        this.isVisible = false;
        this.loadDataParent.emit(true);
      } else {
        this.notification.create(
          'warning',
          'Cảnh báo',
          res.message
        );
      }
      this.isLoadingBtn = false;

    }, (err) => {
      this.notification.create(
        'error',
        'Thất bại',
        err
      );
      this.isLoadingBtn = false;

    });


  }

  showModal(id: any): void {

    this.idDistributor = id;
    this.isVisible = true;
    if (this.idDistributor) {
      this.distributorsService.detailDistributor(this.idDistributor).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
        const name = res.data.name;
        const tax_code = res.data.tax_code;
        this.form_step1.get('name').setValue(name);
        this.form_step1.get('tax_code').setValue(tax_code);

        this.form_step1.get('address').setValue(res.data.address);
        this.countries.map(c => {
          if (c.id === res.data.countryId) {
            this.form_step1.get('country_id').setValue(c.id + '-' + c.code);
          }
        });
        this.form_step1.get('province_id').setValue(res.data.area_Id);
        this.rootService.listDistricts(res.data.area_Id).pipe(takeUntil(this.unsubscribe$)).subscribe((value) => {
          this.districts = value.data.items;
          this.form_step1.get('district_id').setValue(res.data.district_id);
          this.rootService.listWards(res.data.district_id).pipe(takeUntil(this.unsubscribe$)).subscribe((value: any) => {
            this.street = value.data.items;
            this.form_step1.get('streetId').setValue(res.data.streetId);
          });
        });
        this.form_step1.get('phone').setValue(res.data.phone);
        this.form_step1.get('email').setValue(res.data.email);
        this.form_step1.get('website').setValue(res.data.website);
        this.form_step1.get('avatar').setValue(res.data.image);
        this.form_step1.get('background').setValue(res.data.image_org);
        this.form_step1.get('intro').setValue(res.data.intro);
        this.form_step1.get('introImage').setValue(res.data.introImage);
        this.form_step1.get('introVideo').setValue(res.data.introVideo);
        this.form_step1.get('addressNew').setValue(res.data.addressNew);
        this.form_step1.get('addressNewName').setValue(res.data.addressNewName);
        this.form_step1.get('provinceNewId').setValue(res.data.provinceNewId);
        this.form_step1.get('wardNewId').setValue(res.data.wardNewId);
        this.avatar = [{url: res.data.image_org}];
        this.background = [{url: res.data.background_org}];
        this.introVideo = res.data.introVideo ? [...res.data.introVideo] : [];
        this.introImage = [];
        if (res.data.introImage) {
          for (const item of res.data.introImage)  {
            this.introImage.push({url: item});
          }
        } else {
          this.introImage  = [];
        }

        console.log(this.introVideo);
        console.log(this.introImage);
      });
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
